/**
 * @generated SignedSource<<44be54521ecf7a8ed52673e2660d20aa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type src_issueTableHideDoneToggle_HideDoneItemsToggle_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueTableHideDoneToggle_HideDoneItemsToggle_project">;
  readonly " $fragmentType": "src_issueTableHideDoneToggle_HideDoneItemsToggle_project";
};
export type src_issueTableHideDoneToggle_HideDoneItemsToggle_project$key = {
  readonly " $data"?: src_issueTableHideDoneToggle_HideDoneItemsToggle_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"src_issueTableHideDoneToggle_HideDoneItemsToggle_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "src_issueTableHideDoneToggle_HideDoneItemsToggle_project",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ui_issueTableHideDoneToggle_HideDoneItemsToggle_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "986313360c57f0d08dd42d2ba59a9699";

export default node;
